var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isChildComponentLoaded)?_c('role-info-form',{attrs:{"formEdit":_vm.formEdit,"isEditPage":true},on:{"on-submit":_vm.editRole}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }